import sortBy from 'lodash/sortBy';

import { addQuoteLine } from './actions';
import { connectEditor } from './connect-editor';
import ProductSelection from './ProductSelection';

export default connectEditor(
  ({ productsById, quote, quoteLinesById, opportunity }) => ({
    products: sortBy(
      Object.values(productsById).filter(product => !product.deprecated),
      'sortingRank',
    ),
    opportunity,
    quote,
    quoteLineProducts: quote.quoteLines
      .map(id => quoteLinesById[id])
      .map(quoteLine => productsById[quoteLine.productId]),
  }),
  {
    onAddQuoteLine: addQuoteLine,
  },
  // Default implementation required to be able to provide the options
  (stateProps, dispatchProps, ownProps) => ({
    ...dispatchProps,
    ...stateProps,
    ...ownProps,
  }),
  // Premature optimization: Ignore changes to the quote lines.
  {
    areStatesEqual: (nextState, prevState) =>
      nextState.productsById === prevState.productsById &&
      nextState.quote === prevState.quote,
  },
)(ProductSelection);
